
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/refer-earn",
      function () {
        return require("private-next-pages/refer-earn/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/refer-earn"])
      });
    }
  